"use client";

import React from "react";
import Script from "next/script";
import Header from "@/components/layout/Header";
import { Mail, Phone, Sparkles } from "lucide-react";
import SupportContactInlineForm from "./SupportContactInlineForm";

export default function ContactUsContent() {
	return (
		<div className="min-h-screen bg-white">
			<Script
				src="https://challenges.cloudflare.com/turnstile/v0/api.js"
				strategy="afterInteractive"
			/>
			<Header />
			<main
				className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20"
				style={{ marginTop: "10rem" }}
			>
				<h1 className="sr-only">
					Contact Tax Lien Vest - Get in Touch
				</h1>

				<div className="grid lg:grid-cols-2 gap-6 md:gap-8 lg:gap-16 items-start max-w-6xl mx-auto">
					<div className="order-2 lg:order-1 bg-[#16251c] rounded-2xl lg:rounded-3xl p-6 sm:p-8 md:p-10 lg:p-12 text-white shadow-2xl">
						<div className="mb-6 md:mb-10">
							<div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-white/10 rounded-xl lg:rounded-2xl flex items-center justify-center mb-4 lg:mb-6 backdrop-blur-sm border border-white/10">
								<Sparkles className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-[#A7FF5E]" />
							</div>
							<h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 md:mb-4 tracking-tight">
								Contact Us
							</h2>
						</div>

						<div className="space-y-6 md:space-y-8">
							<div className="flex items-start gap-3 sm:gap-5 group">
								<div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[#A7FF5E] rounded-full flex items-center justify-center shrink-0 shadow-lg group-hover:scale-110 transition-transform">
									<Mail className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-[#16251c]" />
								</div>
								<div className="flex-1 min-w-0">
									<p className="text-[#edffde] text-xs sm:text-sm mb-1 sm:mb-2 font-medium uppercase tracking-wide">
										Email us
									</p>
									<a
										href="mailto:support@taxlienvest.com"
										className="text-white text-base sm:text-lg lg:text-xl font-bold hover:text-[#A7FF5E] transition-colors inline-block break-all"
									>
										support@taxlienvest.com
									</a>
								</div>
							</div>

							<div className="flex items-start gap-3 sm:gap-5 group">
								<div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[#A7FF5E] rounded-full flex items-center justify-center shrink-0 shadow-lg group-hover:scale-110 transition-transform">
									<Phone className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-[#16251c]" />
								</div>
								<div className="flex-1 min-w-0">
									<p className="text-[#edffde] text-xs sm:text-sm mb-1 sm:mb-2 font-medium uppercase tracking-wide">
										Call us
									</p>
									<a
										href="tel:+13214857963"
										className="text-white text-base sm:text-lg lg:text-xl font-bold hover:text-[#A7FF5E] transition-colors inline-block"
									>
										+1 (321) 485-7963
									</a>
								</div>
							</div>
						</div>

						<div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-white/10">
							<p className="text-[#8c99a7] text-sm leading-relaxed">
								Our support team typically responds within 24
								hours during business days. Verifying your email
								after you submit helps us prioritize your
								request.
							</p>
						</div>
					</div>
					<div className="order-1 lg:order-2 bg-white rounded-2xl lg:rounded-3xl border border-gray-200 shadow-xl p-6 sm:p-8 md:p-10 lg:p-12">
						<SupportContactInlineForm
							variant="landing"
							idPrefix="landing"
						/>
					</div>
				</div>
			</main>

			<script
				type="application/ld+json"
				dangerouslySetInnerHTML={{
					__html: JSON.stringify({
						"@context": "https://schema.org",
						"@type": "ContactPage",
						name: "Contact Tax Lien Vest",
						description:
							"Get in touch with Tax Lien Vest support team. Contact us via email or phone for assistance with tax lien property investments.",
						url: "https://taxlienvest.com/contact-us",
						mainEntity: {
							"@type": "Organization",
							name: "Tax Lien Vest",
							email: "support@taxlienvest.com",
							telephone: "+1-321-485-7963",
							url: "https://taxlienvest.com",
						},
					}),
				}}
			/>
		</div>
	);
}
